import React, { Component } from 'react'
import styled from 'styled-components'
import { Helmet } from 'react-helmet'
import { connect } from 'react-redux'
import Typography from '../../UI/Typography'
import Select from '../../UI/Form/Select'
import ScrollNav from '../../UI/ScrollNav'
import SplitSection from '../../UI/Slider/SplitSection'
import Button from '../../UI/Button'
import TabSlider from '../../UI/TabSlider'
import PriceSection from '../../UI/Misc/Price'
import { fetchDurations, fetchProduct } from '../../../actions/calculator'
import { device } from '../../../utils/helpers'
import { Element, Events } from 'react-scroll'

import Feature from '../../UI/Feature'
import { features } from './Contenimento'
import {
  basketSlides1,
  basketSlides2,
  basketSlides3,
  basketSlides4
} from '../../Helpers/Slides'
import CampoIcon from '../../UI/Icons/CampoIcon'
import CanestroIcon from '../../UI/Icons/CanestroIcon'
import {
  Section,
  Title,
  BigTitle,
  FeatureWrapper,
  Features,
  Menu,
  Content,
  Customize,
  CustomizeOptions,
  CustomizeHeading,
  FormGroup
} from './Altre'

const Icon = ({ icon, ...props }) => (
  // Needed to pass props to the element which is also being
  // passed as props
  React.cloneElement(icon, { ...props })
)

const StyledIcon = styled(Icon)`
  width: ${props => props.width};
  height: ${props => props.height};

  @media ${device.tablet} {
    width: ${props => props.tabWidth};
    height: ${props => props.tabHeight};
  }
`

const navItems = [
  {
    name: 'Campo',
    icon: <StyledIcon icon={<CampoIcon />} width='75px' height='75px' tabWidth='3.90625VW' tabHeight='3.90625VW' fill='#4d4d4d' />
  },
  {
    name: 'Canestro',
    icon: <StyledIcon icon={<CanestroIcon />} width='75px' height='75px' tabWidth='3.90625VW' tabHeight='3.90625VW' fill='#4d4d4d' />
  }
]

export const campo = {
  description: 'Dal 3vs3 al 5vs5 le installazioni di campi o metà campo di pallacanestro sono sempre più diffuse in Italia. Determinante fondamentale del prodotto è la resa della superficie di gioco. Noleggiocampi.it utilizza il miglior prodotto sul mercato affidandosi alle superfici utilizzate nelle maggiori competizioni europee outdoor.',
  tabs: [
    {
      title: 'PIASTRELLE',
      content: 'Materiale campo: Piastrelle in polipropilene (25x25 cm) con Sistema swiss-flex (maggiore flessibilità e rapido drenaggio dell’acqua);Materiali dotati di certificazione;Non necessita di ancoraggio al suolo',
      goToSlideIndex: 0
    },
    {
      title: 'STRUTTURA',
      content: 'Bordo campo brandizzabili;Telo PVC per copertura campo in caso di pioggia;Impianto di illuminazione;Impianto audio e diffusione sonora',
      goToSlideIndex: 2
    }
  ]
}

export const canestro = {
  description: <div>
    <Typography variant='h6' type='subtitle'>CANESTRO SPALDING PRO CON TABELLONE TRASPARENTE</Typography>
    <span>Materiale dotato di certificazione</span><br />
    <span>Montaggio con certificazione statica</span><br />
    <span>Non necessita ancoraggio al suolo</span><br />
    <span>Ferro professionale per Slum Dunk Contest</span><br />
    <span>Altezza regolabile per basket e minibasket</span><br />
  </div>,
  tabs: [
    {
      title: 'TABELLONE',
      content: 'Il tabellone in plexiglass trasparente può essere brandizzato con adesivo monomerico opaco/lucido resistente all’acqua.',
      goToSlideIndex: 4
    },
    {
      title: 'STRUTTURA',
      content: 'La base del canestro SPALDING PRO è provvista di una protezione formata da cuscini in gomma piuma nero lucido e resistente all’acqua. Può essere brandizzata con adesivo monomerico lucido/opaco resistente all’acqua di dimensione massima 50x50 cm.',
      goToSlideIndex: 0
    }
  ]
}

const UList = styled.ul`
  font-size: 18px;
  padding: 0 1.2rem;
  font-family: 'BarlowSemiBold';
`

const SubSection = styled.div`
  @media ${device.laptopL} {
    display: flex;
    justify-content: space-between;
  }
`

class CampoBasket extends Component {
  constructor (props) {
    super(props)
    this.state = {
      sticky: false,
      quantita: [
        {
          id: 1,
          name: '1'
        },
        {
          id: 2,
          name: '2'
        },
        {
          id: 3,
          name: '3'
        },
        {
          id: 4,
          name: '4'
        }
      ],
      currentQuantita: {
        id: 1,
        name: '1'
      },
      currentDuration: {},
      currentAddon: {
        id: 1,
        name: 'NESSUNA',
        amount: 0
      },
      amount: ''
    }
  }

  componentDidMount () {
    Events.scrollEvent.register('begin', function () {
      console.log('begin', arguments)
    })

    Events.scrollEvent.register('end', function () {
      console.log('end', arguments)
    })

    window.addEventListener('scroll', this.handleScroll.bind(this))
    this.props.fetchDurations(null, (durations) => {
      this.setState({ currentDuration: durations[0] })
    })
    this.props.fetchProduct(1, (product) => {
      this.setState({ amount: product.amount })
    })
  }

  handleScroll (event) {
    const sticky = this.menu && this.menu.offsetTop
    if (window.pageYOffset > sticky - 100) {
      this.setState({ sticky: true })
    }

    if (window.pageYOffset < 165) {
      this.setState({ sticky: false })
    }
  }

  handleQuantitySelection (item) {
    const { currentProduct } = this.props
    const { currentDuration, currentAddon } = this.state
    let baseAmount = (currentProduct.amount + (currentAddon ? currentAddon.amount : 0))
    // (Base amount + currently selected addon else 0) * quantity * currently selected duration
    let amount = (baseAmount + (baseAmount * currentDuration.coefficient)) * item.id
    this.setState({ currentQuantita: item, amount })
  }

  handleDurationSelection (item) {
    const { currentProduct } = this.props
    const { currentQuantita, currentAddon } = this.state
    let baseAmount = (currentProduct.amount + (currentAddon ? currentAddon.amount : 0))
    // (Base amount + currently selected addon else 0) * quantity * currently selected duration
    let amount = (baseAmount + (baseAmount * item.coefficient)) * currentQuantita.id
    this.setState({ currentDuration: item, amount })
  }

  handleAddonSelection (item) {
    console.log(item)
    const { currentProduct } = this.props
    const { currentQuantita, currentDuration } = this.state
    let baseAmount = (currentProduct.amount + (item ? item.amount : 0))
    // (Base amount + currently selected addon else 0) * quantity * currently selected duration
    let amount = (baseAmount + (baseAmount * currentDuration.coefficient)) * currentQuantita.id
    this.setState({ currentAddon: item, amount })
  }

  render () {
    const { amount } = this.state
    const { durations, currentProduct } = this.props
    let addonOptions = [{
      id: 1,
      name: 'NESSUNA',
      amount: 0
    }]
    currentProduct.addons && currentProduct.addons.map((item, i) => {
      if (item.amount) {
        addonOptions.push({
          id: i + 2,
          name: item.name,
          amount: item.amount
        })
      }
    })
    console.log(addonOptions)
    return (
      <div>
        <Helmet>
          <title>Noleggio Campo da basket</title>
          <meta name='Description' content='Con il nostro servizio di CONFIGURAZIONE puoi creare il tuo campo da basket street 3x3 o 5x5. Personalizza il canestro da basket e rendi TOP il tuo evento!' />
          <meta name='Keywords' content='canestro da basket,campo basket smontabile,pavimentazione campo basket esterno' />
        </Helmet>
        <Title>
          <Typography variant='h1' type='title'>CAMPO DA BASKET</Typography>
        </Title>
        <Menu innerRef={menu => (this.menu = menu)} className={this.state.sticky ? 'sticky' : ''}>
          <ScrollNav items={navItems} />
        </Menu>
        <Content>
          {/* CAMPO */}
          <Element name='campo' >
            <SplitSection slides={basketSlides1} reverse reverseMobile>
              <Typography variant='h2' type='title'>CAMPO</Typography>
              <Typography padding='1.2rem 0' minSize='16px' maxSize='21px'>
                {campo.description}
              </Typography>
              <SubSection>
                <div>
                  <Typography padding='1.2rem 0' variant='h5' type='title'>Tipologie</Typography>
                  <UList>
                    <li>
                      BASKET 3vs3 <br />
                      <span style={{ color: '#999999' }}>DIMENSIONI: 14x9 m (ingombro 15x10m)</span>
                    </li>
                    <li>
                      BASKET 5vs5 <br />
                      <span style={{ color: '#999999' }}>DIMENSIONI: 28x15 m (ingombro 32x19m)</span>
                    </li>
                  </UList>
                </div>
                <div>
                  <Typography padding='1.2rem 0' variant='h5' type='title'>NOLEGGIA UN CAMPO PER IL TUO EVENTO!</Typography>
                  <Button size='small' primary to='/noleggia/basket/1'>CREA PREVENTIVO</Button>
                </div>
              </SubSection>
            </SplitSection>
            <TabSlider
              slides={basketSlides2}
              tabs={campo.tabs}
              title='Dettagli Tecnici'
            />
          </Element>
          {/* CANESTRO */}
          <Element name='canestro' >
            <SplitSection slides={basketSlides3} reverse>
              <Typography variant='h2' type='title'>Canestro</Typography>
              <Typography padding='1rem 0 0 0' minSize='16px' maxSize='21px'>
                {canestro.description}
              </Typography>

              <Customize>
                <CustomizeHeading>NOLEGGIA CANESTRO</CustomizeHeading>
                <CustomizeOptions>
                  <FormGroup padding='0 10px 0 0'>
                    <Select
                      title='Quantita'
                      list={this.state.quantita}
                      default={this.state.currentQuantita}
                      selected={this.handleQuantitySelection.bind(this)}
                    />
                  </FormGroup>
                  <FormGroup padding='0 10px 0 0'>
                    <Select
                      title='Durata'
                      list={durations}
                      default={durations[0]}
                      selected={this.handleDurationSelection.bind(this)}
                    />
                  </FormGroup>
                  <FormGroup>
                    <Select
                      title='Personalizzazione'
                      list={addonOptions}
                      default={this.state.currentAddon}
                      selected={this.handleAddonSelection.bind(this)}
                    />
                  </FormGroup>
                  <PriceSection
                    product={this.props.currentProduct}
                    quantity={this.state.currentQuantita}
                    duration={this.state.currentDuration}
                    addon={this.state.currentAddon}
                    amount={amount}
                  />
                </CustomizeOptions>
              </Customize>
            </SplitSection>
            <TabSlider
              slides={basketSlides4}
              tabs={canestro.tabs}
              title='Dettagli Tecnici'
            />
          </Element>
        </Content>
        <Section>
          <BigTitle>
            <Typography variant='h2' type='title'>
              4 BUONI MOTIVI PER SCEGLIERE LE NOSTRE STRUTTURE
            </Typography>
          </BigTitle>
          <Features>
            {features.map(feature => (
              <FeatureWrapper>
                <Feature
                  icon={feature.icon}
                  title={feature.title}
                  description={feature.description}
                />
              </FeatureWrapper>
            ))}
          </Features>
        </Section>
      </div>
    )
  }
}

function mapStateToProps (state) {
  return {
    durations: state.calculator.durations,
    currentProduct: state.calculator.currentProduct
  }
}

export default connect(mapStateToProps, { fetchDurations, fetchProduct })(CampoBasket)



// WEBPACK FOOTER //
// ./src/components/Pages/Strutture/CampoBasket.js